module.exports = __webpack_public_path__ + "img/kong.93b819b8.png";